// services/everpro/everpro-order/createBody.ts - create.ts split (sub-module build body)

import type { CreateEverproOrderParams } from '../everpro-types';
import { toRFC3339WIB } from '../everpro-shipping';

export const normalizePhone = (p: string) => {
  const digits = p.replace(/\D/g, '');
  if (digits.startsWith('0')) return '62' + digits.slice(1);
  if (digits.startsWith('62')) return digits;
  return digits;
};

export function buildCreateOrderBody(params: CreateEverproOrderParams): Record<string, any> {
  const dimensionCm = params.dimensionCm || { length: 10, width: 10, height: 10 };

  const body: Record<string, any> = {
    client_order_no: params.clientOrderNo,
    shipper_name: params.shipperName,
    shipper_phone: normalizePhone(params.shipperPhone),
    shipper_address: params.shipperAddress,
    shipper_postal_code: params.shipperPostalCode,
    // Nama desa asal/tujuan WAJIB sama persis dengan request get rate yang
    // mencetak signed_key (sign key mengikat sender/receiver location —
    // insiden "Sign key tidak valid" J&T EZ Bp Mahdi Warsono 2026-10-24).
    // API Create V2 mendukung kedua field ini (contoh resmi Everpro).
    ...(params.shipperSubDistrictName ? { shipper_sub_district_name: params.shipperSubDistrictName } : {}),
    receiver_name: params.receiverName,
    receiver_phone: normalizePhone(params.receiverPhone),
    receiver_address: params.receiverAddress,
    receiver_postal_code: params.receiverPostalCode,
    ...(params.receiverSubDistrictName ? { receiver_sub_district_name: params.receiverSubDistrictName } : {}),
    package_desc: params.packageDesc.substring(0, 150),
    package_price: params.packagePrice,
    package_type_id: 1,
    height: Math.ceil(dimensionCm.height),
    width: Math.ceil(dimensionCm.width),
    length: Math.ceil(dimensionCm.length),
    weight: params.weightKg,
    rate_code: params.rateCode,
    signed_key: params.signedKey,
    shipment_price: params.shipmentPrice,
    shipment_type: params.shipmentType,
    min_duration: params.minDuration,
    max_duration: params.maxDuration,
    is_cod: params.isCOD ?? false,
    is_flat_rate: params.isFlatRate ?? false,
    insurance_price: 0,
    is_use_insurance: false,
  };

  // cashback dari response rate — WAJIB dikirim sama persis (bagian sign key; sandbox
  // membuktikan rate ber-cashback gagal kalau cashback dikirim 0/omitted).
  if (params.cashback != null) body.cashback = params.cashback;

  if (params.isCOD && params.codPrice) body.cod_price = Math.round(params.codPrice);

  // Everpro Go backend (CreateOrderV2Request.pickup_time) WAJIB string RFC3339:
  // "YYYY-MM-DDTHH:mm:ss+07:00" (validasi pesan error: "please use RFC3339 time format: YYYY-MM-DDTHH:mm:ss+07:00").
  // JANGAN kirim number (Unmarshal error) dan JANGAN .toISOString() (UTC Z bikin jam 14 WIB terbaca jam 7 pagi).
  body.pickup_time = toRFC3339WIB(params.pickupTime || '');

  return body;
}
